<nz-result [nzStatus]="error.status" [nzTitle]="error.status" [nzSubTitle]="error.statusText">
    <div nz-result-extra>
        <button nz-button nzType="primary" (click)="backToHome()">Back To Dashboard</button>
    </div>
</nz-result>